'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Style = require('../core/Style');

var _ExpandableConstants = require('./ExpandableConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var INDENT_OPTIONS = {
  default: _ExpandableConstants.EXPANDABLE_PADDING_LEFT,
  compact: _ExpandableConstants.EXPANDABLE_PADDING_X,
  none: 0
};

var StyledContents = _styledComponents2.default.div.withConfig({
  displayName: 'UIExpandableContents__StyledContents'
})(['padding-bottom:', ';padding-left:', ';padding-right:', ';padding-top:', ';>:last-child{margin-bottom:0;}'], (0, _Style.remCalc)(_ExpandableConstants.EXPANDABLE_PADDING_BOTTOM), function (props) {
  return typeof props.indentation === 'number' ? (0, _Style.remCalc)(props.indentation) : (0, _Style.remCalc)(INDENT_OPTIONS[props.indentation]);
}, function (props) {
  return props.indentation === 'none' ? 0 : (0, _Style.remCalc)(_ExpandableConstants.EXPANDABLE_PADDING_X);
}, function (props) {
  return props.indentation === 'none' ? 0 : (0, _Style.remCalc)(_ExpandableConstants.EXPANDABLE_PADDING_TOP);
});

var UIExpandableContents = function UIExpandableContents(props) {
  var children = props.children,
      indentation = props.indentation,
      rest = _objectWithoutProperties(props, ['children', 'indentation']);

  return _react2.default.createElement(
    StyledContents,
    _extends({}, rest, { indentation: indentation }),
    children
  );
};

UIExpandableContents.propTypes = {
  children: _react.PropTypes.node,
  indentation: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(Object.keys(INDENT_OPTIONS))])
};

UIExpandableContents.defaultProps = {
  indentation: 'default'
};

UIExpandableContents.displayName = 'UIExpandableContents';

exports.default = UIExpandableContents;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/accordion/UIExpandableContents.js
// module id = 654
// module chunks = 3 4